import { Component, Input, OnChanges, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { AnalyticsService } from '../../service/analytics/analytics.service';
import { Review } from '../../model/review/review.model';
import { StoreRatingSummary, StoreReview } from '../../service/store/store.service';
import { ToolPublicReview, ToolReviewService } from '../../service/tool-review/tool-review.service';
import { toolReviewCards } from '../../util/review-cards';

/**
 * The bottom of every tool page (owner, 2026-10-04): the tool's approved ratings
 * (average, count, the comments) and the visitor's own rating. The page's
 * WebApplication structured data carries the same numbers (seo-route-meta.js).
 */
@Component( {
  selector: 'app-tool-rating',
  templateUrl: './tool-rating.component.html',
  styleUrls: [ './tool-rating.component.scss' ],
} )
export class ToolRatingComponent implements OnChanges, OnDestroy {

  /** "color", "palette", "gradient", "wallpaper", "dynamic-wallpaper" or a converter's slug ("hex-to-rgb") */
  @Input() toolKey = '';
  @Input() toolName = 'This Tool';
  /** the color pages tint their headings with the color on the page */
  @Input() accent: string | null = null;

  summary: StoreRatingSummary | null = null;
  reviews: ToolPublicReview[] = [];
  /** the comments as the home wall's bubbles */
  cards: Review[] = [];
  mine: StoreReview | null = null;
  mineLoaded = false;

  private subs: Subscription[] = [];

  constructor( private toolReviewService: ToolReviewService, private analyticsService: AnalyticsService ) {
  }

  readonly send = ( rating: number, comment: string, displayName: string ) =>
    this.toolReviewService.submit( this.toolKey, rating, comment, displayName );

  ngOnChanges(): void {
    this.subs.forEach( s => s.unsubscribe() );
    this.subs = [];
    this.mineLoaded = false;
    if ( !this.toolKey ) {
      return;
    }
    this.subs.push( this.toolReviewService.reviews().subscribe( data => {
      this.summary = data.tools[ this.toolKey ] ?? null;
      this.reviews = data.reviews.filter( r => r.tool === this.toolKey );
      // the pill names the tool ("Color Explorer", not "the Color Explorer")
      this.cards = toolReviewCards( this.reviews, this.toolName.replace( /^the\s+/i, '' ) );
    } ) );
    this.subs.push( this.toolReviewService.mine( this.toolKey ).subscribe( res => {
      this.mine = res.review;
      this.mineLoaded = true;
    } ) );
  }

  onSaved( review: StoreReview ): void {
    this.mine = review;
    this.analyticsService.logEvent( 'Tool Review Submitted', { tool: this.toolKey, rating: review.rating, hasComment: !!review.comment } );
  }

  ngOnDestroy(): void {
    this.subs.forEach( s => s.unsubscribe() );
  }
}
